<template lang="html">
  <div class="editing-box"
    :style="getStyle"
    v-if="$store.state.editingState.id !== 0"
    draggable="true"
    @dragstart="dragstartHandler"
    @dragend="dragendHandler">
    <div>
      {{ $store.state.editingState.start }} ~
    </div>
    <div>
      {{ $store.state.editingState.end }}
    </div>
    <div>
      {{ getStudent() }} 様
    </div>
    <div>
      {{ getTeacher() }} 先生
    </div>
    <div style="color: #888888">
      ドラッグで移動
    </div>
  </div>
</template>

<script>
import {
  EDITING_POPUP_SHOW,
  EDITINGBOX_STYLE_UPDATE,
  EDITINGBOX_DRAG_START,
  EDITINGBOX_DRAG_END,
  EDITING_POPUP_HIDE
} from '@/vuex/mutation_types'
import {
  mapGetters
} from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'timeToPosition',
      'getLeftPosOfClassroom'
    ]),
    getStyle () {
      const top = this.timeToPosition(this.$store.state.editingState.start.replace(/px/g, ''))
      const bottom = this.timeToPosition(this.$store.state.editingState.end.replace(/px/g, ''))
      const height = bottom - top
      const left = this.getLeftPosOfClassroom(this.$store.state.editingState.classroom)
      const style = {
        top: top + 'px',
        left: left + 'px',
        height: height + 'px',
        width: this.$store.state.columnWidth + 'px'
      }
      this.$store.commit(EDITINGBOX_STYLE_UPDATE, style)
      return style
    }
  },
  methods: {
    getTeacher () {
      for (let lect of this.$store.state.lectureInfo) {
        if (lect.teacher.id === this.$store.state.editingState.teacher) {
          return lect.teacher.fullname
        }
      }
    },
    getStudent () {
      for (let lect of this.$store.state.lectureInfo) {
        if (lect.student.id === this.$store.state.editingState.student) {
          return lect.student.fullname
        }
      }
    },
    dragstartHandler (e) {
      let offsets = {
        x: e.layerX,
        y: e.layerY
      }
      e.dataTransfer.setData('text/json', JSON.stringify(offsets))
      this.$store.commit(EDITINGBOX_DRAG_START)
      this.$store.commit(EDITING_POPUP_HIDE)
    },
    dragendHandler (e) {
      this.$store.commit(EDITINGBOX_DRAG_END)
      this.$store.commit(EDITING_POPUP_SHOW)
    }
  }
}
</script>

<style lang="css" scope>
.editing-box {
  box-sizing: border-box;
  background-color: white;
  border-style: dotted;
  border-color: #ffd500;
  position: absolute;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// EditingBox.vue?42c86bbc